import { useMemo } from "react";

import {
  ExperimentTitleNames,
  useActiveExperiment,
  useOptimizelyContext,
} from "scmp-app/lib/optimizely";

import { AbWidgetFetchVariant } from "./constants";

export const useAbWidgetVariant = (): {
  isLoading: boolean;
  variant: AbWidgetFetchVariant | null;
} => {
  const { initialized: optimizelyInitialized } = useOptimizelyContext();
  const { experiment } = useActiveExperiment(ExperimentTitleNames.HomeMid);

  return useMemo(() => {
    if (!optimizelyInitialized) {
      return { isLoading: true, variant: null };
    }

    const variationName = experiment?.variation?.name;

    if (variationName === "0") {
      return { isLoading: false, variant: AbWidgetFetchVariant.Control };
    }
    if (variationName === "1") {
      return { isLoading: false, variant: AbWidgetFetchVariant.V1 };
    }
    if (variationName === "2") {
      return { isLoading: false, variant: AbWidgetFetchVariant.V2 };
    }

    return { isLoading: false, variant: null };
  }, [optimizelyInitialized, experiment?.variation?.name]);
};
